"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cpdCourseRequiresReview = cpdCourseRequiresReview;
exports.cpdCourseReviewerRoles = cpdCourseReviewerRoles;
const REVIEW_REQUIRED_TOPICS = new Set(['safeguarding', 'send_inclusion']);
/**
 * Determines whether a CPD course requires named reviewer sign-off
 * before it can be published.
 *
 * @param course - Pick of ICpdCourse with only the topic field
 * @returns true if the course requires review (safeguarding or send_inclusion)
 */
function cpdCourseRequiresReview(course) {
    return REVIEW_REQUIRED_TOPICS.has(course.topic);
}
/**
 * Returns the required reviewer role tags for a CPD course's topic.
 *
 * - safeguarding: ['dsl', 'deputy_dsl', 'admin']
 * - send_inclusion: ['sendco', 'admin']
 * - other topics: ['admin'] (ordinary content QA)
 *
 * @param course - Pick of ICpdCourse with only the topic field
 * @returns Array of StaffRoleTag values that may approve the course
 */
function cpdCourseReviewerRoles(course) {
    switch (course.topic) {
        case 'safeguarding':
            return ['dsl', 'deputy_dsl', 'admin'];
        case 'send_inclusion':
            return ['sendco', 'admin'];
        default:
            return ['admin'];
    }
}
